import { Component, Inject, PLATFORM_ID, Renderer2 } from '@angular/core';
import { RevealDirective } from '../../../directives/reveal.directive';
import { AnalyticsService } from '../../../services/analytics.service';
import { ContactUsComponent } from '../../../landing-page-v1/components/contact-us/contact-us.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-hero',
  standalone: true,
  imports: [RevealDirective],
  templateUrl: './hero.component.html',
})
export class HeroComponent {
  constructor(
    private dialog: MatDialog,
    private renderer: Renderer2,
    private analyticsService: AnalyticsService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {}
  onStartNowClicked(): void {
    this.analyticsService.trackEvent('start_now_click', {
      event_category: 'Button',
      event_label: 'Start Now button click',
    });
  }

  onContactUsClicked() {
    const dialogRef = this.dialog.open(ContactUsComponent, {
      disableClose: true,
      autoFocus: false,
    });

    this.analyticsService.trackEvent('request_demo_click', {
      event_category: 'Button',
      event_label: 'Request a Demo button click',
    });

    dialogRef.afterClosed().subscribe((result) => {});
  }
}
